import React from "react";
import Header from "../components/header";
import Seo from "../components/seo";
import info from "../info.json";
import ReCAPTCHA from "react-google-recaptcha";

import { useStaticQuery, graphql, Link } from "gatsby";
import { IconArrowNarrowRight, IconInfoSmall } from "@tabler/icons-react";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import { navigate } from "gatsby";

export default function Contact({ data }) {
  const [isHover, setIsHover] = React.useState(false);

  const { title, slug, content, uri } = data.wpPage;
  const {
    maintitle,
    phoneEcuador,
    phoneMiami,
    emailAddress,
    address,
    addressEC,
    linkedin,
    instagram,
    tiktok,
    youtube,
    facebook,
    iconImageBg,
    terms,
  } = data.wpPage.contactFields;
  const socialMedia = [
    { name: "Instagram", url: instagram },
    { name: "Linkedin", url: linkedin },
    { name: "Tiktok", url: tiktok },
    { name: "Facebook", url: facebook },
    { name: "Youtube", url: youtube },
  ];

  const RECAPTCHA_V2_SITE_KEY = "6LeB8hIrAAAAAPV23iBuiOIbOILdbFxyDLfO_42v";

  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [currentPage, setCurrentPage] = React.useState("Contact");
  const [phone, setPhone] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [company, setCompany] = React.useState("");
  const [city, setCity] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [quantity, setQuantity] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [token, setToken] = React.useState("");

  const captchaToken = React.useRef();

  function onChangeCaptcha() {
    setToken(captchaToken.current.getValue());
  }

  const [error, setError] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);

  function resetStates() {
    setSubmitted(false);
    setError("");
  }

  function resetForm() {
    setName("");
    setEmail("");
    setMessage("");
  }

  function onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    resetStates();

    if (!token) {
      setError("Please complete the google recaptcha challenge");
      return;
    }

    fetch("https://formcarry.com/s/WZgwARyyZge", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        currentPage,
        name,
        email,
        phone,
        country,
        company,
        city,
        description,
        quantity,
        message,
        "g-recaptcha-response": token,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.code === 200) {
          navigate("/success");
        } else if (response.code === 422) {
          // Field validation failed
          setError(response.message);
        } else {
          // other error from formcarry
          setError(response.message);
        }
      })
      .catch((error) => {
        // request related error.
        setError(error.message ? error.message : error);
      });
  }

  const inputRef = React.useRef(null);
  const buttonRef = React.useRef(null);

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  function focus(e) {
    e.stopPropagation(); // Stop event propagation here
    handleFocus();
  }

  const handleClick = () => {
    if (buttonRef.current) {
      buttonRef.current.click();
    }
  };
  function click(e) {
    e.stopPropagation(); // Stop event propagation here
    handleClick();
  }

  const inputs = info.form.inputs.map((item) => {
    return (
      <input
        type="text"
        className="w-full bg-charcoal capitalize placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our text-sm lg:text-base xl:text-xl"
        placeholder={item.placeholder}
      />
    );
  });

  // function handleSubmit(event) {
  //     event.preventDefault();

  //     const myForm = event.target;
  //     const formData = new FormData(myForm);

  //     fetch('/', {
  //         method: "POST",
  //         headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //         body: new URLSearchParams(formData).toString(),
  //     })
  //         .then(response => response.json())
  //         .then(data => {
  //             console.log(data);
  //         })
  //         .catch(error => {
  //             console.error('Error:', error);
  //         });
  // }

  React.useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  });

  return (
    <main className="bg-charcoal lg:h-auto lg:min-h-[100vh] w-[100vw] lg:flex lg:flex-row lg:justify-center lg:items-center">
      <Header />
      {/* pt-[150px] pb-[100px] lg:pt-[300px] lg:pb-[200px] px-4 lg:px-[90px] 2xl:px-[200px] */}
      <section className="relative flex flex-col lg:flex-row w-full h-full justify-center items-center lg:gap-[8vh] text-white max-w-screen-2xl mx-auto pt-[150px]  lg:pt-[100px] px-[20px] md:px-[60px] lg:px-[100px]">
        <section className="flex flex-col justify-between items-center lg:items-start w-fit">
          <StaticImage
            src="../images/icon-rf-white.png"
            className="w-[100px] mb-10"
            objectFit="contain"
            objectPosition={"0% 0%"}
          />

          <h1 className="text-7xl sm:text-8xl md:text-9xl xl:text-9xl 2xl:text-11xl leading-auto  text-center lg:text-left text-nowrap">
            LET'S GET <br /> IN TOUCH
          </h1>
          <nav className="hidden lg:block mt-20">
            <ul className="flex flex-wrap gap-5 text-2xl">
              {socialMedia.map((item) => {
                return (
                  <span className="group w-fit">
                    <a
                      className="font-caslon"
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.name}
                    </a>
                    <span className="block max-w-0 group-hover:max-w-full transition-all duration-500 h-[1px] bg-cream"></span>
                  </span>
                );
              })}
            </ul>
          </nav>
        </section>
        <section className="flex flex-col justify-center gap-8 w-full">
          <form
            className="flex flex-col mb-2 gap-[1.5vh] 2xl:gap-[2vh] w-full "
            name="contact"
            onSubmit={(e) => onSubmit(e)}
          >
            <div className="formcarry-block">
              <input
                className="w-full bg-charcoal capitalize placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our"
                onChange={(e) => setName(e.target.value)}
                required
                type="text"
                name="name"
                placeholder={"Name"}
                ref={inputRef}
                onTouchEnd={(e) => {
                  focus(e);
                }}
              />
            </div>

            <div className="flex justify-between gap-8">
              <div className="formcarry-block w-full ">
                <input
                  className="w-full bg-charcoal capitalize placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  type="email"
                  name="email"
                  placeholder={"Email"}
                  ref={inputRef}
                  onTouchEnd={(e) => {
                    focus(e);
                  }}
                />
              </div>

              <div className="formcarry-block w-full ">
                <input
                  className="w-full bg-charcoal capitalize placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our"
                  onChange={(e) => setPhone(e.target.value)}
                  required
                  type="tel"
                  name="phone"
                  placeholder={"Phone Number"}
                  ref={inputRef}
                  onTouchEnd={(e) => {
                    focus(e);
                  }}
                />
              </div>
            </div>

            <div className="flex gap-2">
              <div className="formcarry-block w-full ">
                <input
                  className="w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our"
                  onChange={(e) => setCountry(e.target.value)}
                  required
                  type="text"
                  name="$country"
                  placeholder={"Country"}
                  ref={inputRef}
                  onTouchEnd={(e) => {
                    focus(e);
                  }}
                />
              </div>

              <div className="formcarry-block w-full ">
                <input
                  className="w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our"
                  onChange={(e) => setCity(e.target.value)}
                  required
                  type="text"
                  name="$city"
                  placeholder={"City"}
                  ref={inputRef}
                  onTouchEnd={(e) => {
                    focus(e);
                  }}
                />
              </div>
            </div>

            <div className="formcarry-block">
              <select
                onChange={(e) => setDescription(e.target.value)}
                id="description"
                name="$description"
                className="w-full bg-charcoal text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our"
                ref={inputRef}
                onTouchEnd={(e) => {
                  focus(e);
                }}
              >
                <option value="default" selected disabled>
                  What describes you the best
                </option>
                <option value="Wholesaler">Wholesaler</option>
                <option value="Event Planner">Event Planner</option>
                <option value="Retailer">Retailer</option>
              </select>
            </div>

            <div className="formcarry-block">
              <input
                className="w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our"
                onChange={(e) => setCompany(e.target.value)}
                required
                type="text"
                name="$company"
                placeholder={"Company"}
                ref={inputRef}
                onTouchEnd={(e) => {
                  focus(e);
                }}
              />
            </div>

            <div className="flex items-end gap-4 relative">
              <div className="w-full">
                <div className="formcarry-block">
                  <select
                    onChange={(e) => setQuantity(e.target.value)}
                    id="quantity"
                    name="$quantity"
                    className="w-full h-full bg-charcoal text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-out"
                    ref={inputRef}
                    onTouchEnd={(e) => {
                      focus(e);
                    }}
                  >
                    <option value="default" selected disabled>
                      Quantity
                    </option>
                    <option value="100-500">100-500</option>
                    <option value="500-1000">500-1000</option>
                    <option value="More than 1000">More than 1000</option>
                  </select>
                </div>
              </div>

              <div
                className="group aspect-square border border-cream/50 hover:bg-cream/10 transition-all ease-in-out pointer static"
                id="info-btn"
              >
                <IconInfoSmall
                  size={25}
                  stroke={1}
                  className="block md:hidden"
                />
                <IconInfoSmall
                  size={40}
                  stroke={1}
                  className="hidden md:block"
                />
                <div
                  className="info absolute w-full h-full flex items-center bg-charcoal text-cream/80 top-0 left-0 leading-[20px] p-px opacity-0 invisible group-hover:visible group-hover:opacity-100 transition-opacity ease-in-out duration-200"
                  id="info-data"
                >
                  <p className="underline underline-offset-4">
                    How many stems of roses do you demand in a weekly basis
                  </p>
                </div>
              </div>
            </div>

            <div className="formcarry-block">
              <input
                className="w-full bg-charcoal placeholder:text-cream/50 border-b border-cream/50 focus:border-cream/100 rounded-none focus:outline-none transition-all duration-150 ease-in-our"
                onChange={(e) => setMessage(e.target.value)}
                required
                type="text"
                name="message"
                placeholder={"Message"}
                ref={inputRef}
                onTouchEnd={(e) => {
                  focus(e);
                }}
              />
            </div>

            <div className="formcarry-block">
              <ReCAPTCHA
                ref={captchaToken}
                sitekey={RECAPTCHA_V2_SITE_KEY}
                onChange={onChangeCaptcha}
              />
            </div>

            <div className="formcarry-block">
              <input
                type="submit"
                value="CONTACT"
                className="min-w-[200px] self-end pointer border duration-100 transition-bg ease-in-out hover:text-black hover:bg-white px-6 py-2"
                ref={inputRef}
                onTouchEnd={(e) => {
                  focus(e);
                }}
                style={{ cursor: "pointer" }}
                onMouseOver={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
              ></input>
            </div>

            <section
              className=" text-white/50 terms"
              dangerouslySetInnerHTML={{ __html: terms }}
            ></section>
          </form>

          <section className="flex flex-row flex-wrap gap-y-4 gap-x-7 xl:justify-between">
            <section className="flex flex-col">
              <h5 className="font-caslon text-base  2xl:text-xl">
                Phone Numbers:
              </h5>
              <span className="group w-fit">
                <a
                  href={`tel:${phoneMiami}`}
                  id="phoneMiami"
                  target="_blank"
                  className="font-caslon text-sm w-fit"
                >
                  Miami: {phoneMiami}
                </a>
                <span className="block max-w-0 group-hover:max-w-full transition-all duration-500 h-[1px] bg-cream"></span>
              </span>

              <span className="group w-fit">
                <a
                  href={`tel:${phoneEcuador}`}
                  id="phoneEcuador"
                  target="_blank"
                  className="font-caslon text-sm"
                >
                  Ecuador: {phoneEcuador}
                </a>
                <span className="block max-w-0 group-hover:max-w-full transition-all duration-500 h-[1px] bg-cream"></span>
              </span>
            </section>

            <section className="flex flex-col">
              <h5 className="font-caslon text-base 2xl:text-xl">
                Email Address:
              </h5>
              <span className="group w-fit">
                <a
                  href={`mailto:${emailAddress}`}
                  id="emailBtn"
                  target="_blank"
                  className="font-caslon text-sm"
                >
                  {emailAddress}
                </a>
                <span className="block max-w-0 group-hover:max-w-full transition-all duration-500 h-[1px] bg-cream"></span>
              </span>
            </section>

            <section className="flex flex-col">
              <h5 className="font-caslon text-base  2xl:text-xl">Address:</h5>
              <span className="group w-fit">
                <a
                  href={`https://maps.app.goo.gl/3tPhoGXeGxatRe3U6`}
                  id="mapMiami"
                  target="_blank"
                  className="font-caslon text-sm"
                >
                  USA: {address}
                </a>
                <span className="block max-w-0 group-hover:max-w-full transition-all duration-500 h-[1px] bg-cream"></span>
              </span>

              <span className="group w-fit">
                <a
                  href={`https://maps.app.goo.gl/W4fzw4o8u6Yt888y9?g_st=ic`}
                  id="mapEcuador"
                  target="_blank"
                  className="font-caslon text-sm"
                >
                  Ecuador: {addressEC}
                </a>
                <span className="block max-w-0 group-hover:max-w-full transition-all duration-500 h-[1px] bg-cream"></span>
              </span>
            </section>
          </section>

          <nav className="block lg:hidden mt-6 mb-4">
            <ul className="flex flex-wrap gap-4 lg:gap-12 text-2xl">
              {socialMedia.map((item) => {
                return (
                  <span className="group w-fit">
                    <a
                      className="font-caslon"
                      id={item.name}
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.name}
                    </a>
                    <span className="block max-w-0 group-hover:max-w-full transition-all duration-500 h-[1px] bg-cream"></span>
                  </span>
                );
              })}
            </ul>
          </nav>
        </section>
      </section>
    </main>
  );
}

export function Head({ data }) {
  const {
    wpPage: { seo },
  } = data;

  return (
    <Seo
      title={seo.title}
      description={seo.metaDesc}
      url={data.site.siteMetadata.siteUrl + "/contact"}
    ></Seo>
  );
}

export const query = graphql`
  query Contact {
    site {
      siteMetadata {
        siteUrl
      }
    }
    wpPage(title: { eq: "Contact" }) {
      title
      slug
      content
      uri
      seo {
        title
        metaDesc
        canonical
      }
      contactFields {
        maintitle
        phoneEcuador
        phoneMiami
        emailAddress
        address
        addressEC
        linkedin
        instagram
        tiktok
        youtube
        facebook
        terms
        iconImageBg {
          node {
            gatsbyImage(width: 1000, placeholder: NONE)
          }
        }
      }
    }
  }
`;
